import React from "react";
import { makeStyles } from "@mui/styles";
import { Box, Chip, Grid, Typography } from "@mui/material";

const ChipSelection = ({
  values,
  maxSelection,
  backgroundColor,
  color,
  size = "small",
  onDelete,
}) => {
  const isLarge = size != "small";
  const useStyles = makeStyles(() => ({
    container: {
      border: "1px solid hsl(160, 10%, 90%)",
      borderRadius: "12px",
      backgroundColor: "#fff",
      width: "100%",
      height: isLarge ? "120px" : "56px",
      display: "flex",
      alignItems: isLarge ? "start" : "center",
      paddingTop: isLarge ? "8px" : "0px",
      paddingBottom: isLarge ? "8px" : "0px",
      paddingLeft: "8px",
      paddingRight: "8px",
      overflowX: isLarge ? "hidden" : "auto",
      flexWrap: "wrap",
    },
    chip: {
      height: "40px",
      borderRadius: "9999px",
      margin: "4px",
      backgroundColor: `${backgroundColor} !important`,
      color: `${color} !important`,
      "& > .MuiChip-deleteIcon": {
        color: `${color} !important`,
      },
    },
  }));
  const classes = useStyles();

  return (
    <Grid container>
      <Grid item xs={12}>
        <Box className={classes.container}>
          {values?.map((value, i) => {
            return (
              <Chip
                key={`${value.label}`}
                label={
                  <Typography component="span" variant="body2" color="inherit">
                    {value?.label}
                  </Typography>
                }
                className={classes.chip}
                style={{
                  marginLeft: i > 0 ? "8px" : "0px",
                }}
                onDelete={() => onDelete(value)}
              />
            );
          })}
        </Box>
      </Grid>
      {maxSelection && (
        <Grid item xs={12} align="right">
          <Typography>
            {values?.length || 0} / {maxSelection}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default ChipSelection;
